import ReactDOM from 'react-dom';


const ModalPortal = ({ children }:any) => {
  const modalRoot:any = document.getElementById('modal-root');
  return ReactDOM.createPortal(children, modalRoot);
};

export default ModalPortal;
